import React, { useState, useRef, forwardRef, useEffect } from 'react';
import { Grid, Divider } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { Link, Card } from '@rcg/ui-react';
import VerticalDivider from '@rcg/ui-react/lib/components/Icons/VerticalDivider';
import CalendarIcon from '@rcg/ui-react/lib/assets/svg/calendar';
import { buildCalendarStateObject } from '@rcg/ui-react/lib/utils/dates';
import NavButton from '@rcg/ui-react/lib/components/DatepickerResponsive/NavButton';
import Button from '../../../../UiComponents/Button';
import Calendar from '../Calendar';
import useStyles from './index.style';
import InputRangeDate from '../InputRangeDate';

// eslint-disable-next-line react/display-name
const CalendarPicker = forwardRef((props, ref) => {
  const {
    datepickerIcon = <CalendarIcon />,
    dividerInputIcon = <VerticalDivider />,
    placeholderStartDate = 'Start date',
    placeholderEndDate = 'End date',
    resetDatesButtonLabel = 'Reset',
    incomingStartDate = '2021/03/20',
    incomingEndDate = '2021/03/25',
    minAvailableDate = '2021/03/5',
    maxAvailableDate = '2021/04/25',
    yourDatesLabel = 'your dates',
    startDate = new Date(),
    endDate = new Date(),
    submitDatesButtonLabel = 'Done',
    onDateChange = () => {},
    resetCalendar = () => {},
    oneWay = false,
    handleDatepicker = () => {},
  } = props;
  const classes = useStyles();
  const [state, setState] = useState(buildCalendarStateObject(startDate, endDate));
  const calendarRef = useRef();

  useEffect(() => {
    handleDatepicker(state);
  }, [state]);

  const setPickerDates = (dates) => {
    setState(dates);
  };
  const onDoneClick = () => {
    onDateChange(state);
  };
  const onResetClick = () => {
    setState(buildCalendarStateObject(incomingStartDate, incomingEndDate));
    resetCalendar();
  };

  return (
    <div className={classes.wrapPicker} ref={ref}>
      <Card className={classes.wrapCalendarPicker}>
        <div className={classes.datepickerHeader}>
          <Grid container justify="flex-end">
            <Grid item xl={6} className={classes.datepickerHeaderInputs}>
              <Grid container justify="flex-end" style={{ flexWrap: 'nowrap' }}>
                <Grid item xl={2} style={{ maxWidth: 'unset' }}>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <Link
                    component="button"
                    underline="none"
                    className={classes.resetButton}
                    onClick={onResetClick}>
                    {resetDatesButtonLabel}
                  </Link>
                </Grid>
                <Grid item xl={10} className={classes.datepickerHeaderInput}>
                  <InputRangeDate
                    datepickerIcon={datepickerIcon}
                    dividerInputIcon={dividerInputIcon}
                    placeholderStartDate={placeholderStartDate}
                    placeholderEndDate={placeholderEndDate}
                    labelDatepicker=""
                    startDate={state.startDate}
                    endDate={state.endDate}
                    focusedInput={state.focusedInput}
                    oneWay={oneWay}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Divider />
        <div className={classes.datepickerBody}>
          <div className={classes.datepickerMessages}>
            <div className={classes.underscore} /> {yourDatesLabel}
          </div>
          <div className={classes.datepickerCalendar}>
            <Calendar
              maxAvailableDate={maxAvailableDate}
              minAvailableDate={minAvailableDate}
              incomingStartDate={incomingStartDate}
              incomingEndDate={incomingEndDate}
              startDate={state.startDate}
              endDate={state.endDate}
              ref={calendarRef}
              onDateChange={setPickerDates}
              singleDaySelection={oneWay}
            />
          </div>
        </div>
        <div className={classes.datepickerFooter}>
          <Grid container justify="flex-end">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={onDoneClick}
                data-testid="doneButton">
                {submitDatesButtonLabel}
              </Button>
            </Grid>
          </Grid>
        </div>
        <NavButton direction onClick={() => calendarRef.current.previousMonth()}>
          <ChevronLeftIcon fontSize="small" />
        </NavButton>
        <NavButton onClick={() => calendarRef.current.nextMonth()}>
          <ChevronRightIcon fontSize="small" />
        </NavButton>
      </Card>
    </div>
  );
});

export default CalendarPicker;
